const STORAGE_KEY = "sb_test_auth_organization";

/**
 * Resolves which Auth0 Organization the legacy SPA client is bound to (spec:
 * dedicated-deployment/specs/20_shadow_test_org.md). Only the single
 * allowlisted test org can override the pinned org, and the choice persists
 * in sessionStorage so silent token renewal (hidden-iframe code flow, which
 * re-mounts the provider) keeps requesting the test org. The storage key matches packages/ui
 * and ui-deployed-shell, so one shadow-org choice on this origin covers every
 * tree the session traverses (dashboard, editor/workflow, deployed view).
 */
export function resolveAuthOrganization(envs: {
  get(name: string): string;
}): string {
  const pinned = envs.get("SUPERBLOCKS_UI_AUTH_ORGANIZATION");
  const testOrg = envs.get("SUPERBLOCKS_UI_TEST_AUTH_ORGANIZATION");
  if (!testOrg) return pinned;

  const requested = new URLSearchParams(window.location.search).get(
    "organization",
  );
  if (requested === testOrg) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, testOrg);
    } catch {
      // sessionStorage unavailable (e.g. blocked): fall through, still honor this load
    }
    return testOrg;
  }
  // Any other value is genuinely ignored: fall through to the stored choice
  // instead of returning `pinned` for this one render. Returning pinned here
  // while sessionStorage still held the test org knocked an in-flight test
  // session out of the test org for a single provider mount, then flipped back
  // on the next render (the worst of both). The param can only ever SELECT the
  // test org; it can never switch a session away from it.

  try {
    if (window.sessionStorage.getItem(STORAGE_KEY) === testOrg) return testOrg;
  } catch {
    // sessionStorage unavailable: degrade to pinned org
  }
  return pinned;
}
